export const companyName = 'softteco';

export const companyNameFull = 'SoftTeco';

export const supportLink = 'https://help.softteco-tools.com/';

export const howToReportBug =
  'https://docs.google.com/document/d/1RXzGAUtbjjmQyGGCiNdiq63pY6BNl8tiRMEwaDELmas/edit#heading=h.50ofwtuhd3kp';

export const iFrameUrl = `${process.env.REACT_APP_AUTH_MODULE}#/home?iframe=1&env=${process.env.REACT_APP_AUTHORIZE_ENV}`;

export const supportEmail = 'bench.support@softteco.com';
